// =============================================================================
// Support mode — this browser TAB is WTF Go support inside an owner's dashboard.
//
// A support tab is opened by the admin console (Owners → Open dashboard) and lands on
// /support/enter#t=<support token>. Everything about it lives in sessionStorage, which
// is per tab: the admin's own login (localStorage persist:authUser) is never touched,
// two support tabs for two owners never mix, and closing the tab drops the token.
//
// redux/store.js decides ONCE at boot where the auth slice persists: sessionStorage in
// support mode AND on the hand-off link itself, so the hand-off logs in and moves to /app
// in-app — no second page load.
// =============================================================================
export const SUPPORT_FLAG = "wtf.supportMode";
export const SUPPORT_ENDED = "wtf.supportEnded";
export const SUPPORT_ENDED_EVENT = "wtf:support-ended";
const PERSIST_KEY = "persist:authUser";   // must match redux/store.js persistConfig.key

const ss = () => { try { return window.sessionStorage; } catch (e) { return null; } };

export const isSupportMode = () => {
  try { return ss()?.getItem(SUPPORT_FLAG) === "1"; } catch (e) { return false; }
};

// The tab is ON the hand-off link (/support/enter#t=…): not confirmed yet, but it must
// boot on this tab's own storage, never on the admin's login.
export const isSupportHandoff = (loc) => {
  try {
    const l = loc || window.location;
    return l.pathname === "/support/enter" && /(^#|&)t=/.test(String(l.hash || ""));
  } catch (e) { return false; }
};

export const supportEnded = () => {
  try { return ss()?.getItem(SUPPORT_ENDED) === "1"; } catch (e) { return false; }
};

// Seed this tab's auth exactly the way redux-persist v6 stores it (each value is
// itself JSON), so the store rehydrates as an authenticated owner session.
export const enterSupportMode = (user) => {
  const s = ss();
  if (!s) return false;
  s.removeItem(SUPPORT_ENDED);
  s.setItem(SUPPORT_FLAG, "1");
  s.setItem(PERSIST_KEY, JSON.stringify({
    isAuthenticated: JSON.stringify(true),
    user: JSON.stringify(user),
    _persist: JSON.stringify({ version: -1, rehydrated: true }),
  }));
  return true;
};

// The session is over (ended by anyone, or refused by the server). The tab keeps its
// state only to show the "ended" screen; the token is dead server-side either way.
export const markSupportEnded = () => {
  try { ss()?.setItem(SUPPORT_ENDED, "1"); } catch (e) { /* noop */ }
  try { window.dispatchEvent(new Event(SUPPORT_ENDED_EVENT)); } catch (e) { /* noop */ }
};

// Where the multi-gym "active gym" lives: per tab in support mode, shared otherwise.
export const activeGymStorage = () => {
  try { return isSupportMode() ? window.sessionStorage : window.localStorage; } catch (e) { return null; }
};
